<script lang="ts" module>
  import { useActions } from "#lib/internal/helpers"
  import type { BaseProps } from "#lib/internal/types"
  import { getPopperRootContext } from "./PopperRoot.svelte"

  export type Props = BaseProps & {
    as?: "div" | "button" | "a"
    ref?: HTMLElement | null
    type?: BaseProps<"button">["type"]
    disabled?: boolean
    children?: any
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte"

  type AnchorProps = Props & { children?: Snippet }

  let {
    use = [],
    as = "div",
    type = as === "button" ? "button" : undefined,
    ref = $bindable(),
    children,
    ...restProps
  }: AnchorProps = $props()

  let element: HTMLElement = $state()!

  const rootContext = getPopperRootContext()

  $effect(() => {
    if (element) ref = element
  })

  $effect(() => {
    rootContext.anchor = element
  })
</script>

<svelte:element
  this={as}
  {type}
  {...restProps}
  use:useActions={use ?? []}
  bind:this={element}
>
  {@render children?.()}
</svelte:element>
